import React from "react";
import { TransitionProvider } from "./src/context/TransitionContext";

// Element to provide the transition context
export const wrapRootElement = ({ element }) => {
  return <TransitionProvider>{element}</TransitionProvider>;
};

// Set scroll restoration to 'manual' and handle scrolling properly
export const onClientEntry = () => {
  if (typeof window !== 'undefined' && window.history) {
    // Set scroll restoration to manual
    window.history.scrollRestoration = 'manual';
    
    // Immediately set scroll position to top on page load
    window.scrollTo(0, 0);
    
    // Create a flag to track if this is the first load
    window.__FIRST_LOAD = true;
    
    // Listen for the first scroll event after load
    window.addEventListener('scroll', function firstScrollHandler() {
      // Only execute this once
      if (window.__FIRST_LOAD && window.__LENIS) {
        console.log("First scroll event detected, resetting position");
        window.__FIRST_LOAD = false;
        
        // Force scroll to top with Lenis
        window.__LENIS.scrollTo(0, { immediate: true });
        
        // Remove this listener after first execution
        window.removeEventListener('scroll', firstScrollHandler);
      }
    });
  }
};

// Scroll to top when navigating to a new page
export const onRouteUpdate = ({ location, prevLocation }) => {
  console.log(`Route changed to: ${location.pathname}`);
  
  if (typeof window !== 'undefined') {
    // Force scroll to top with native method immediately
    window.scrollTo(0, 0);
    
    // Set a flag to indicate we need to scroll to top when Lenis is available
    window.__NEED_SCROLL_RESET = true;
    
    // Try with Lenis if available
    if (window.__LENIS) {
      console.log("Lenis available during route change, resetting position");
      window.__LENIS.stop();
      window.__LENIS.scrollTo(0, { immediate: true });
      setTimeout(() => {
        window.__LENIS.start();
      }, 50);
      
      // We've handled the scroll reset
      window.__NEED_SCROLL_RESET = false;
    }
    
    // Check again after a delay to catch late initialization
    setTimeout(() => {
      if (window.__LENIS && window.__NEED_SCROLL_RESET) {
        console.log("Lenis now available, resetting position");
        window.__LENIS.scrollTo(0, { immediate: true });
        window.__NEED_SCROLL_RESET = false;
      }
    }, 300);
  }
  
  return true;
};

// Add a transition container around each page
export const wrapPageElement = ({ element }) => {
  return (
    <div className="page-transition-container">
      {element}
    </div>
  );
};

// Prevent Gatsby from handling scroll updates
export const shouldUpdateScroll = () => {
  return false;
};